import styled from 'styled-components';

export const Main = styled.main`
    padding-top: 65px;
    min-height: calc(100vh - 151px);
    @media (max-width: 767px) {
        padding-top: 52px;
    }
`;
